var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading', _vm.showBackground ? 'show-background' : '']},[_c('div',{ref:"spinner",staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])])}
var staticRenderFns = []

export { render, staticRenderFns }